import { Box, BoxProps } from '@mui/material'
import owlImg from '@/assets/img/icons/common/owl.png'

export default function OwlIcon({ sx, ...props }: BoxProps<'img'>) {
    return (
        <Box
            component="img"
            src={owlImg}
            alt=""
            {...props}
            sx={{ width: 50, height: 50, display: 'block', ...sx }}
        />
    )
}
